import { jsx as _jsx } from "react/jsx-runtime";

function SvgRefresh() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.27 6.543a1 1 0 00.759 1.27l5.773 1.166a1 1 0 10.396-1.96l-3.57-.72A8 8 0 114 13a1 1 0 10-2 0c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10-1.806 0-3.5.479-4.963 1.316l.92-3.026A1 1 0 006.043.71L4.27 6.543z"
    }, void 0)
  }), void 0);
}

export default SvgRefresh;